import { reduce } from 'lodash';
import PropTypes from 'prop-types';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const newOrderFormContext = createContext(null);

export const NewOrderFormProvider = ({ children, stepsLength }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formState, setFormState] = useState(
    reduce(new Array(stepsLength), (res, _, index) => ({ ...res, [index.toString()]: false }), {})
  );

  const updateFormState = useCallback(
    ({ step, valid }) => setFormState((prev) => ({ ...prev, [step]: valid })),
    []
  );

  const memoizedValue = useMemo(
    () => ({
      currentStep,
      setCurrentStep,
      formState,
      updateFormState,
    }),
    [currentStep, formState, updateFormState]
  );

  return (
    <newOrderFormContext.Provider value={memoizedValue}>{children}</newOrderFormContext.Provider>
  );
};

NewOrderFormProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  stepsLength: PropTypes.number.isRequired,
};

const useNewOrderForm = () => useContext(newOrderFormContext);

export default useNewOrderForm;
